module.exports = __webpack_public_path__ + "static/media/rr-logo.43c616d4.svg";